import React from 'react';
import { Dropdown, Menu, Modal } from 'antd';
import Api from '../../../../services/Api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faEllipsisV,
} from '@fortawesome/free-solid-svg-icons';
import { Flex, Avatar, objectArraySort } from '@mss/mss-component-library';
import { TFunction } from 'i18next';

const GroupMembersColumns = (
  t: TFunction,
  fetchGroupMembers: () => void,
  superAdminGroup: boolean,
  hasPermission: (permission: string | string[]) => boolean
) => [
  {
    title: '',
    dataIndex: 'user',
    key: 'user',
    width: 30,
    render: (a: any, record: any) => {
      return (
        <Flex h="center" v="center">
          <Avatar firstName={record.first_name} lastName={record.last_name} />
        </Flex>
      );
    },
  },
  {
    title: t('User'),
    dataIndex: 'first_name',
    key: 'name',
    render: (a: any, record: any) => `${record.first_name} ${record.last_name}`,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'first_name'),
  },
  {
    title: t('Email address'),
    dataIndex: 'email',
    key: 'email',
    width: 250,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'email'),
  },
  {
    title: t('Status'),
    dataIndex: 'is_active',
    key: 'is_active',
    width: 100,
    render: (active: boolean) => (active ? 'Active' : 'Inactive'),
  },
  {
    title: '',
    dataIndex: 'relationId',
    key: 'relationId',
    width: 40,
    align: 'center',
    render: (record: any, fullRecord: any) => {
      return (
        <span
          style={{ width: 24, display: 'block' }}
          onClick={e => e.stopPropagation()}
        >
          {hasPermission('delete_usergroup') && !superAdminGroup && (
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    onClick={() => {
                      Modal.confirm({
                        title: t(`Remove group member`),
                        icon: (
                          <span className="anticon">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              color="#fd9644"
                              size="sm"
                            />
                          </span>
                        ),
                        content: t(
                          `You're about to remove the user with the email '(EMAIL)' from this group. Are you sure?`,
                          { recordEmail: fullRecord.email }
                        ),
                        onOk: async () => {
                          await Api.group.user.remove(record);
                          fetchGroupMembers();
                        },
                      });
                    }}
                  >
                    {t('Delete')}
                  </Menu.Item>
                </Menu>
              }
              trigger={['click']}
            >
              <div style={{ width: 24 }}>
                <FontAwesomeIcon icon={faEllipsisV} />
              </div>
            </Dropdown>
          )}
        </span>
      );
    },
  },
];

export default GroupMembersColumns;
